import React from 'react';
import { useParams, Navigate, useLocation } from 'react-router-dom';

// Importar os dados globais de cidades
import { CITIES_DATA } from '../../data/citiesData';
import BlogArticles from '../../../pages/institucional/blog/BlogArticles';
import ContactCTA from '../common/ContactCTA';
import MapAndCards from '../common/MapAndCards';
import Header from '../common/Header';
import Services from '../common/Services';
import { useTheme } from '../../contexts/ThemeContext';
import ContactDrawer from '../common/ContactDrawer';
import MapAndCardsHomeCare from '../common/MapAndCardsHomeCare';

export default function Cities() {
    const { theme } = useTheme();
    const location = useLocation();
    const { id } = useParams();

    // 2. Lógica da URL
    const cityId = id ? id.toLowerCase() : null;
    const city = CITIES_DATA[cityId];

    // Verifica se a URL atual é a que rastreamos (ex: /city/ribeirao/active)
    const isActive = location.pathname.startsWith(`/city/${id}/active`);

    // Se o ID não for válido, redireciona para a página inicial ou 404
    if (!city) {
        return <Navigate to="/" replace />;
    }

    return (
        <div className="bg-slate-100 min-h-screen">
            {/* Header: Passa o objeto completo da cidade apenas se estiver na rota /active. 
               Se o Header precisar do objeto da sessão, ele o pega via useEntryTracking. 
            */}
            <Header city={isActive ? city : null} isActive={city} />

            {/* Hero Section */}
            <section
                className="relative h-[650px] sm:h-[750px] md:h-[650px] flex flex-col items-center px-4 pt-16"
                style={{
                    // IMAGEM DINÂMICA
                    backgroundImage: `url(${city.img})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="absolute top-[160px] w-full md:max-w-5xl max-w-[320px] bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg p-3 flex items-center flex-col justify-center md:flex-row md:justify-between pointer-events-auto mx-4 z-20">
                    <div className="pl-8">
                        {/* DADOS DINÂMICOS */}
                        <p className="text text-gray-900">Bem vindo ao nosso Polo em {city.name}</p>
                        <p className="text-sm text-gray-400">{city.shortName} • {city.contactInfo}</p>
                        <p className="text-sm text-gray-400">Horário: {city.hours}</p>
                    </div>
                    <div className="hidden md:flex flex-row">
                        <p className="text-sm text-gray-400 max-w-md px-2">
                            Preencha o formulário a seguir com a sua solicitação de orçamento, crítica ou sugestão que retornaremos o mais breve possível.
                        </p>
                    </div>
                    <button className="bg-black text-white font-sm text-sm mt-6 mr-8 px-4 md:py-1 rounded-full hover:bg-gray-800 transition-colors whitespace-nowrap pointer-events-auto" onClick={() => window.open(`https://wa.me/${city.phone}`, "_blank")}>
                        Fale com um especialista
                    </button>
                </div>

                <div className="absolute bottom-8">
                    <div className="max-w-7xl w-full mx-auto flex mb-3 items-center bg-white/70 backdrop-blur-sm p-2 md:py-2 md:px-20 rounded-md shadow-xl">
                        <p className="text-gray-500 text-sm md:text-base font-xs text-center">
                            Oferta válida somente no polo de <span className="font-extrabold text-[#004452]">{city.shortName}</span>
                        </p>
                    </div>

                    {/* Card do bottom */}
                    <div className="z-10 md:max-w-7xl max-w-[370px] w-full mx-auto flex flex-col md:flex-row items-center justify-between bg-white/70 backdrop-blur-sm p-4 md:p-6 rounded-xl shadow-xl space-y-4 md:space-y-0">
                        {/* Texto Principal */}
                        <div className="flex-1 px-2 text-center md:text-left">
                            <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-[#004452]">
                                Unidade {city.name}: {city.address}
                            </h2>
                            <p className="text-sm sm:text-base text-[#3a5156] mt-1">
                                Veja nossos serviços disponíveis na região de {city.shortName}.
                            </p>
                        </div>
                        {/* Descrição */}
                        <p className="hidden md:block text-gray-600 text-sm flex-1 md:mx-4">
                            Aqui em {city.name}, oferecemos soluções personalizadas em Home Care, Equipamentos Respiratórios e Aparelhos Auditivos.
                        </p>
                    </div>
                </div>
            </section>
            {theme.context == "" && <Services />}
            <BlogArticles />
            <ContactCTA />
            {theme.context === "homecare"? <MapAndCardsHomeCare /> : <MapAndCards /> }
            <ContactDrawer
                message="Vim do site"
                city={city}
            />
        </div>
    );
}
